import { RouteRecordRaw } from 'vue-router'

const InventoryHub = () =>
  import(/* webpackChunkName: "inventory-hub" */ './pages/index.vue')

const InventoryStock = () =>
  import(/* webpackChunkName: "inventory-stock" */ './pages/stock/index.vue')

const InventoryMovements = () =>
  import(
    /* webpackChunkName: "inventory-movements" */ './pages/movements/index.vue'
  )

const InventoryTransfers = () =>
  import(
    /* webpackChunkName: "inventory-transfers" */ './pages/transfers/index.vue'
  )

const InventoryTransferForm = () =>
  import(
    /* webpackChunkName: "inventory-transfer-form" */ './pages/transfers/FormPage.vue'
  )

const InventoryInTransit = () =>
  import(
    /* webpackChunkName: "inventory-in-transit" */ './pages/in-transit/index.vue'
  )

const InventoryTransferDiscrepancies = () =>
  import(
    /* webpackChunkName: "inventory-discrepancies" */ './pages/discrepancies/index.vue'
  )

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'inventario',
    name: 'inventory-hub',
    component: InventoryHub,
    meta: {
      title: 'Inventario',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/existencias',
    name: 'inventory-stock',
    component: InventoryStock,
    meta: {
      title: 'Existencias',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/movimientos',
    name: 'inventory-movements',
    component: InventoryMovements,
    meta: {
      title: 'Movimientos',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/traspasos',
    name: 'inventory-transfers',
    component: InventoryTransfers,
    meta: {
      title: 'Traspasos',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/traspasos/nuevo',
    name: 'inventory-transfers-create',
    component: InventoryTransferForm,
    meta: {
      title: 'Nuevo traspaso',
      auth: {
        requiredPermission: 'inventory.transfer',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/traspasos/:ulid',
    name: 'inventory-transfers-edit',
    component: InventoryTransferForm,
    meta: {
      title: 'Traspaso',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/en-transito',
    name: 'inventory-in-transit',
    component: InventoryInTransit,
    meta: {
      title: 'En tránsito',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'inventario/discrepancias-traspaso',
    name: 'inventory-transfer-discrepancies',
    component: InventoryTransferDiscrepancies,
    meta: {
      title: 'Discrepancias en traspasos',
      auth: {
        requiredPermission: 'inventory.view',
        requiredModule: 'inventory',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
